/**
 * Phone country codes — mirrors Flutter `webCountryCodes`
 * (presentation/web/auth/web_signup/CustomCountryListView.dart) minus
 * CountryCodeConstants.excludedCountries, as shown by CustomDialog.showCountryCodeBottomSheet.
 */

export interface CountryCode {
  iso2: string;
  name: string;
  /** Without the leading '+' */
  phoneCode: string;
}

/** Flutter CountryCodeConstants.myCountryCode */
export const DEFAULT_PHONE_CODE = '91';

export const COUNTRY_CODES: CountryCode[] = [
  { iso2: 'AF', name: 'Afghanistan', phoneCode: '93' },
  { iso2: 'AL', name: 'Albania', phoneCode: '355' },
  { iso2: 'DZ', name: 'Algeria', phoneCode: '213' },
  { iso2: 'AD', name: 'Andorra', phoneCode: '376' },
  { iso2: 'AO', name: 'Angola', phoneCode: '244' },
  { iso2: 'AR', name: 'Argentina', phoneCode: '54' },
  { iso2: 'AM', name: 'Armenia', phoneCode: '374' },
  { iso2: 'AW', name: 'Aruba', phoneCode: '297' },
  { iso2: 'AC', name: 'Ascension Island', phoneCode: '247' },
  { iso2: 'AU', name: 'Australia', phoneCode: '61' },
  { iso2: 'AT', name: 'Austria', phoneCode: '43' },
  { iso2: 'AZ', name: 'Azerbaijan', phoneCode: '994' },
  { iso2: 'BH', name: 'Bahrain', phoneCode: '973' },
  { iso2: 'BD', name: 'Bangladesh', phoneCode: '880' },
  { iso2: 'BY', name: 'Belarus', phoneCode: '375' },
  { iso2: 'BE', name: 'Belgium', phoneCode: '32' },
  { iso2: 'BZ', name: 'Belize', phoneCode: '501' },
  { iso2: 'BJ', name: 'Benin', phoneCode: '229' },
  { iso2: 'BT', name: 'Bhutan', phoneCode: '975' },
  { iso2: 'BO', name: 'Bolivia', phoneCode: '591' },
  { iso2: 'BA', name: 'Bosnia and Herzegovina', phoneCode: '387' },
  { iso2: 'BW', name: 'Botswana', phoneCode: '267' },
  { iso2: 'BR', name: 'Brazil', phoneCode: '55' },
  { iso2: 'IO', name: 'British Indian Ocean Territory', phoneCode: '246' },
  { iso2: 'BN', name: 'Brunei', phoneCode: '673' },
  { iso2: 'BG', name: 'Bulgaria', phoneCode: '359' },
  { iso2: 'BF', name: 'Burkina Faso', phoneCode: '226' },
  { iso2: 'BI', name: 'Burundi', phoneCode: '257' },
  { iso2: 'KH', name: 'Cambodia', phoneCode: '855' },
  { iso2: 'CM', name: 'Cameroon', phoneCode: '237' },
  { iso2: 'CV', name: 'Cape Verde', phoneCode: '238' },
  { iso2: 'BQ', name: 'Caribbean Netherlands', phoneCode: '599' },
  { iso2: 'CF', name: 'Central African Republic', phoneCode: '236' },
  { iso2: 'TD', name: 'Chad', phoneCode: '235' },
  { iso2: 'CL', name: 'Chile', phoneCode: '56' },
  { iso2: 'CO', name: 'Colombia', phoneCode: '57' },
  { iso2: 'KM', name: 'Comoros', phoneCode: '269' },
  { iso2: 'CD', name: 'Democratic Republic Congo', phoneCode: '243' },
  { iso2: 'CG', name: 'Republic of Congo', phoneCode: '242' },
  { iso2: 'CK', name: 'Cook Islands', phoneCode: '682' },
  { iso2: 'CR', name: 'Costa Rica', phoneCode: '506' },
  { iso2: 'CI', name: 'Côte d\'Ivoire', phoneCode: '225' },
  { iso2: 'HR', name: 'Croatia', phoneCode: '385' },
  { iso2: 'CY', name: 'Cyprus', phoneCode: '357' },
  { iso2: 'CZ', name: 'Czech Republic', phoneCode: '420' },
  { iso2: 'DK', name: 'Denmark', phoneCode: '45' },
  { iso2: 'DJ', name: 'Djibouti', phoneCode: '253' },
  { iso2: 'TL', name: 'East Timor', phoneCode: '670' },
  { iso2: 'EC', name: 'Ecuador', phoneCode: '593' },
  { iso2: 'EG', name: 'Egypt', phoneCode: '20' },
  { iso2: 'SV', name: 'El Salvador', phoneCode: '503' },
  { iso2: 'GQ', name: 'Equatorial Guinea', phoneCode: '240' },
  { iso2: 'ER', name: 'Eritrea', phoneCode: '291' },
  { iso2: 'EE', name: 'Estonia', phoneCode: '372' },
  { iso2: 'SZ', name: 'Eswatini', phoneCode: '268' },
  { iso2: 'ET', name: 'Ethiopia', phoneCode: '251' },
  { iso2: 'FK', name: 'Falkland Islands [Islas Malvinas]', phoneCode: '500' },
  { iso2: 'FO', name: 'Faroe Islands', phoneCode: '298' },
  { iso2: 'FJ', name: 'Fiji', phoneCode: '679' },
  { iso2: 'FI', name: 'Finland', phoneCode: '358' },
  { iso2: 'FR', name: 'France', phoneCode: '33' },
  { iso2: 'GF', name: 'French Guiana', phoneCode: '594' },
  { iso2: 'PF', name: 'French Polynesia', phoneCode: '689' },
  { iso2: 'GA', name: 'Gabon', phoneCode: '241' },
  { iso2: 'GM', name: 'Gambia', phoneCode: '220' },
  { iso2: 'GE', name: 'Georgia', phoneCode: '995' },
  { iso2: 'DE', name: 'Germany', phoneCode: '49' },
  { iso2: 'GH', name: 'Ghana', phoneCode: '233' },
  { iso2: 'GI', name: 'Gibraltar', phoneCode: '350' },
  { iso2: 'GR', name: 'Greece', phoneCode: '30' },
  { iso2: 'GL', name: 'Greenland', phoneCode: '299' },
  { iso2: 'GT', name: 'Guatemala', phoneCode: '502' },
  { iso2: 'GN', name: 'Guinea Conakry', phoneCode: '224' },
  { iso2: 'GW', name: 'Guinea-Bissau', phoneCode: '245' },
  { iso2: 'GY', name: 'Guyana', phoneCode: '592' },
  { iso2: 'HT', name: 'Haiti', phoneCode: '509' },
  { iso2: 'HN', name: 'Honduras', phoneCode: '504' },
  { iso2: 'HK', name: 'Hong Kong', phoneCode: '852' },
  { iso2: 'HU', name: 'Hungary', phoneCode: '36' },
  { iso2: 'IS', name: 'Iceland', phoneCode: '354' },
  { iso2: 'IN', name: 'India', phoneCode: '91' },
  { iso2: 'ID', name: 'Indonesia', phoneCode: '62' },
  { iso2: 'IE', name: 'Ireland', phoneCode: '353' },
  { iso2: 'IL', name: 'Israel', phoneCode: '972' },
  { iso2: 'IT', name: 'Italy', phoneCode: '39' },
  { iso2: 'JP', name: 'Japan', phoneCode: '81' },
  { iso2: 'JO', name: 'Jordan', phoneCode: '962' },
  { iso2: 'KZ', name: 'Kazakhstan', phoneCode: '7' },
  { iso2: 'KE', name: 'Kenya', phoneCode: '254' },
  { iso2: 'KI', name: 'Kiribati', phoneCode: '686' },
  { iso2: 'XK', name: 'Kosovo', phoneCode: '383' },
  { iso2: 'KW', name: 'Kuwait', phoneCode: '965' },
  { iso2: 'KG', name: 'Kyrgyzstan', phoneCode: '996' },
  { iso2: 'LA', name: 'Laos', phoneCode: '856' },
  { iso2: 'LV', name: 'Latvia', phoneCode: '371' },
  { iso2: 'LB', name: 'Lebanon', phoneCode: '961' },
  { iso2: 'LS', name: 'Lesotho', phoneCode: '266' },
  { iso2: 'LR', name: 'Liberia', phoneCode: '231' },
  { iso2: 'LI', name: 'Liechtenstein', phoneCode: '423' },
  { iso2: 'LT', name: 'Lithuania', phoneCode: '370' },
  { iso2: 'LU', name: 'Luxembourg', phoneCode: '352' },
  { iso2: 'MO', name: 'Macau', phoneCode: '853' },
  { iso2: 'MK', name: 'Macedonia', phoneCode: '389' },
  { iso2: 'MG', name: 'Madagascar', phoneCode: '261' },
  { iso2: 'MW', name: 'Malawi', phoneCode: '265' },
  { iso2: 'MY', name: 'Malaysia', phoneCode: '60' },
  { iso2: 'MV', name: 'Maldives', phoneCode: '960' },
  { iso2: 'ML', name: 'Mali', phoneCode: '223' },
  { iso2: 'MT', name: 'Malta', phoneCode: '356' },
  { iso2: 'MH', name: 'Marshall Islands', phoneCode: '692' },
  { iso2: 'MQ', name: 'Martinique', phoneCode: '596' },
  { iso2: 'MR', name: 'Mauritania', phoneCode: '222' },
  { iso2: 'MU', name: 'Mauritius', phoneCode: '230' },
  { iso2: 'YT', name: 'Mayotte', phoneCode: '262' },
  { iso2: 'MX', name: 'Mexico', phoneCode: '52' },
  { iso2: 'FM', name: 'Micronesia', phoneCode: '691' },
  { iso2: 'MD', name: 'Moldova', phoneCode: '373' },
  { iso2: 'MC', name: 'Monaco', phoneCode: '377' },
  { iso2: 'MN', name: 'Mongolia', phoneCode: '976' },
  { iso2: 'ME', name: 'Montenegro', phoneCode: '382' },
  { iso2: 'MA', name: 'Morocco', phoneCode: '212' },
  { iso2: 'MZ', name: 'Mozambique', phoneCode: '258' },
  { iso2: 'MM', name: 'Myanmar [Burma]', phoneCode: '95' },
  { iso2: 'NA', name: 'Namibia', phoneCode: '264' },
  { iso2: 'NR', name: 'Nauru', phoneCode: '674' },
  { iso2: 'NP', name: 'Nepal', phoneCode: '977' },
  { iso2: 'NL', name: 'Netherlands', phoneCode: '31' },
  { iso2: 'NC', name: 'New Caledonia', phoneCode: '687' },
  { iso2: 'NZ', name: 'New Zealand', phoneCode: '64' },
  { iso2: 'NI', name: 'Nicaragua', phoneCode: '505' },
  { iso2: 'NE', name: 'Niger', phoneCode: '227' },
  { iso2: 'NG', name: 'Nigeria', phoneCode: '234' },
  { iso2: 'NU', name: 'Niue', phoneCode: '683' },
  { iso2: 'NF', name: 'Norfolk Island', phoneCode: '672' },
  { iso2: 'NO', name: 'Norway', phoneCode: '47' },
  { iso2: 'OM', name: 'Oman', phoneCode: '968' },
  { iso2: 'PW', name: 'Palau', phoneCode: '680' },
  { iso2: 'PS', name: 'Palestinian Territories', phoneCode: '970' },
  { iso2: 'PA', name: 'Panama', phoneCode: '507' },
  { iso2: 'PG', name: 'Papua New Guinea', phoneCode: '675' },
  { iso2: 'PY', name: 'Paraguay', phoneCode: '595' },
  { iso2: 'PE', name: 'Peru', phoneCode: '51' },
  { iso2: 'PH', name: 'Philippines', phoneCode: '63' },
  { iso2: 'PL', name: 'Poland', phoneCode: '48' },
  { iso2: 'PT', name: 'Portugal', phoneCode: '351' },
  { iso2: 'QA', name: 'Qatar', phoneCode: '974' },
  { iso2: 'RO', name: 'Romania', phoneCode: '40' },
  { iso2: 'RW', name: 'Rwanda', phoneCode: '250' },
  { iso2: 'SH', name: 'Saint Helena', phoneCode: '290' },
  { iso2: 'MF', name: 'Saint Martin', phoneCode: '590' },
  { iso2: 'PM', name: 'Saint Pierre and Miquelon', phoneCode: '508' },
  { iso2: 'WS', name: 'Samoa', phoneCode: '685' },
  { iso2: 'SM', name: 'San Marino', phoneCode: '378' },
  { iso2: 'ST', name: 'São Tomé and Príncipe', phoneCode: '239' },
  { iso2: 'SA', name: 'Saudi Arabia', phoneCode: '966' },
  { iso2: 'SN', name: 'Senegal', phoneCode: '221' },
  { iso2: 'RS', name: 'Serbia', phoneCode: '381' },
  { iso2: 'SC', name: 'Seychelles', phoneCode: '248' },
  { iso2: 'SL', name: 'Sierra Leone', phoneCode: '232' },
  { iso2: 'SG', name: 'Singapore', phoneCode: '65' },
  { iso2: 'SK', name: 'Slovakia', phoneCode: '421' },
  { iso2: 'SI', name: 'Slovenia', phoneCode: '386' },
  { iso2: 'SB', name: 'Solomon Islands', phoneCode: '677' },
  { iso2: 'SO', name: 'Somalia', phoneCode: '252' },
  { iso2: 'ZA', name: 'South Africa', phoneCode: '27' },
  { iso2: 'KR', name: 'South Korea', phoneCode: '82' },
  { iso2: 'SS', name: 'South Sudan', phoneCode: '211' },
  { iso2: 'ES', name: 'Spain', phoneCode: '34' },
  { iso2: 'LK', name: 'Sri Lanka', phoneCode: '94' },
  { iso2: 'SR', name: 'Suriname', phoneCode: '597' },
  { iso2: 'SE', name: 'Sweden', phoneCode: '46' },
  { iso2: 'CH', name: 'Switzerland', phoneCode: '41' },
  { iso2: 'TW', name: 'Taiwan', phoneCode: '886' },
  { iso2: 'TJ', name: 'Tajikistan', phoneCode: '992' },
  { iso2: 'TZ', name: 'Tanzania', phoneCode: '255' },
  { iso2: 'TH', name: 'Thailand', phoneCode: '66' },
  { iso2: 'TG', name: 'Togo', phoneCode: '228' },
  { iso2: 'TK', name: 'Tokelau', phoneCode: '690' },
  { iso2: 'TO', name: 'Tonga', phoneCode: '676' },
  { iso2: 'TN', name: 'Tunisia', phoneCode: '216' },
  { iso2: 'TR', name: 'Turkey', phoneCode: '90' },
  { iso2: 'TM', name: 'Turkmenistan', phoneCode: '993' },
  { iso2: 'TV', name: 'Tuvalu', phoneCode: '688' },
  { iso2: 'UG', name: 'Uganda', phoneCode: '256' },
  { iso2: 'UA', name: 'Ukraine', phoneCode: '380' },
  { iso2: 'AE', name: 'United Arab Emirates', phoneCode: '971' },
  { iso2: 'GB', name: 'United Kingdom', phoneCode: '44' },
  { iso2: 'US', name: 'United States', phoneCode: '1' },
  { iso2: 'UY', name: 'Uruguay', phoneCode: '598' },
  { iso2: 'UZ', name: 'Uzbekistan', phoneCode: '998' },
  { iso2: 'VU', name: 'Vanuatu', phoneCode: '678' },
  { iso2: 'VA', name: 'Vatican City', phoneCode: '379' },
  { iso2: 'VE', name: 'Venezuela', phoneCode: '58' },
  { iso2: 'VN', name: 'Vietnam', phoneCode: '84' },
  { iso2: 'WF', name: 'Wallis and Futuna', phoneCode: '681' },
  { iso2: 'ZM', name: 'Zambia', phoneCode: '260' },
  { iso2: 'ZW', name: 'Zimbabwe', phoneCode: '263' },
];

// ── Phone number lengths ───────────────────────────────────────────
// Mirrors Flutter CountryCodeConstants (domain/core/constants/country_code_constants.dart):
// space-separated phone codes per fixed digit count, plus the codes with a min–max range.

const PHONE_NO_7_DIGITS = '297 501 246 691 241 960 692 90 680 677 94 58';
const PHONE_NO_8_DIGITS =
  '374 973 387 226 235 506 357 45 670 503 268 502 504 852 686 383 965 371 961 370 223 356 230 373 377 976 382 50 5227 234 389 47 968 507 675 974 65 228 216 598';
const PHONE_NO_9_DIGITS =
  '93 61 672 994 375 32 359 855 237 56 385 420 593 33 995 233 36 353 972 962 996 352 31 970 972 595 51 48 351 966 421 27 34 41 963 886 66 380 971 84 967 260 263';
const PHONE_NO_10_DIGITS = '684 1 54 880 57 20 44 30 91 98 964 81 7 254 218 52 977 92 63 40 7 90 39';
const PHONE_NO_11_DIGITS = '55';
const PHONE_NO_12_DIGITS = '258';
const DIFF_PHONE_DIGITS = '358 43 229 372 594 49 590 62 39 231 60 596 95 64 262 381 52 82 46';

/** Flutter CountryCodeConstants.countryWithDiffPhoneNoSize */
const COUNTRY_WITH_DIFF_PHONE_NO_SIZE: { cc: string; max: number; min: number }[] = [
  { cc: '358', max: 10, min: 8 },
  { cc: '43', max: 11, min: 10 },
  { cc: '229', max: 9, min: 6 },
  { cc: '372', max: 8, min: 7 },
  { cc: '594', max: 12, min: 9 },
  { cc: '49', max: 11, min: 10 },
  { cc: '590', max: 12, min: 9 },
  { cc: '62', max: 11, min: 9 },
  { cc: '39', max: 13, min: 9 },
  { cc: '231', max: 8, min: 7 },
  { cc: '60', max: 8, min: 7 },
  { cc: '596', max: 12, min: 9 },
  { cc: '95', max: 10, min: 8 },
  { cc: '64', max: 10, min: 8 },
  { cc: '262', max: 12, min: 9 },
  { cc: '381', max: 9, min: 8 },
  { cc: '252', max: 8, min: 7 },
  { cc: '82', max: 10, min: 9 },
  { cc: '46', max: 10, min: 7 },
];

export interface PhoneDigitsSize {
  max: number;
  /** Only set for codes with a range; otherwise the number must have exactly `max` digits */
  min?: number;
}

/**
 * Allowed digit count for a phone code (without '+'), or null when the code isn't listed —
 * mirrors Flutter CountryCodeConstants.getPhoneDigitsSize(), checking the lists in the same order.
 *
 * '52' (Mexico) is in Flutter's diffPhoneDigits but has no range entry, so Flutter's firstWhere
 * throws and the sign-up form can't be submitted. Here it falls through to its 10-digit list.
 */
export function getPhoneDigitsSize(countryCode: string): PhoneDigitsSize | null {
  const isIn = (codes: string) => codes.split(' ').includes(countryCode);

  if (isIn(DIFF_PHONE_DIGITS)) {
    const range = COUNTRY_WITH_DIFF_PHONE_NO_SIZE.find((entry) => entry.cc === countryCode);
    if (range) return { max: range.max, min: range.min };
  }
  if (isIn(PHONE_NO_7_DIGITS)) return { max: 7 };
  if (isIn(PHONE_NO_8_DIGITS)) return { max: 8 };
  if (isIn(PHONE_NO_9_DIGITS)) return { max: 9 };
  if (isIn(PHONE_NO_10_DIGITS)) return { max: 10 };
  if (isIn(PHONE_NO_11_DIGITS)) return { max: 11 };
  if (isIn(PHONE_NO_12_DIGITS)) return { max: 12 };
  return null;
}
